import Vue from "vue";

const getDefaultState = () => {
	return {
		roles: [],
		rolesAvailable: [],
	};
};

const Roles = {
	namespaced: true,
	state: getDefaultState(),
	mutations: {
		SET_ROLES: (state, roles) => {
			state.roles = roles;
			state.rolesAvailable = roles.filter(role => role.id > 2 && role.id !== 7);
		},
		RESET_STATE: state => {
			Object.assign(state, getDefaultState());
		},
	},
	actions: {
		fetchRoles: ({ commit }) => {
			Vue.prototype.$apiService
				.get("roles")
				.then(response => {
					commit("SET_ROLES", response.data);
				})
		},
		resetState: ({ commit }) => {
			commit("RESET_STATE");
		},
	},
	getters: {
		getRole: state => id => {
			if (state.roles) return state.roles.find(role => role.id == id);
			else return false;
		},
		getRoleName: (state, getter) => id => {
			if (getter.getRole(id)) return getter.getRole(id).name;
			else return false;
		},
		// rolesToAssign: state => id => {
		// 	if (state.roles) return state.rolesAvailable.filter(role => role.id >= id);
		// },
	},
};

export default Roles;
